import { Button } from "components/DesignSystem/Button/Button";
import { Compress } from "components/icons/Compress";
import { ExpandCorners } from "components/icons/ExpandCorners";
import { useDispatch, useSelector } from "react-redux";
import { collapseChat, expandChat } from "store/slices/chatExpanded";
import { RootState } from "store/store";

export const ChatExpandToggle = () => {
  const dispatch = useDispatch();
  const isExpanded = useSelector(
    (state: RootState) => state.chatExpanded.isExpanded
  );

  const handleToggle = () => {
    dispatch(isExpanded ? collapseChat() : expandChat());
  };

  const icon = isExpanded ? <Compress /> : <ExpandCorners />;

  return (
    <Button
      type="button"
      customType="secondary"
      size="small"
      className="sm:t-hidden"
      leftIcon={icon}
      onClick={handleToggle}
    >
      {isExpanded ? "Collapse" : "Expand"}
    </Button>
  );
};
